import React, { useEffect, useState } from 'react';
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import ApprovalStepEditor from './ApprovalStepEditor';

const DOC_TYPE_OPTIONS = [
  { value: 'HR_LEAVE', label: '휴가 신청' },
  { value: 'ORDER_BOOK', label: '수주품의서' },
];

const buildInitialState = (data) => ({
  lineNm: data?.lineNm || '',
  docType: data?.docType || 'HR_LEAVE',
  steps: data?.steps?.map((step) => step.assigneeUsrUuid).filter(Boolean) || [''],
});

const ApprovalLineTemplateModal = ({
  open,
  data,
  currentUserUuid,
  onClose,
  onSave,
}) => {
  const [form, setForm] = useState(buildInitialState(data));

  useEffect(() => {
    if (open) {
      setForm(buildInitialState(data));
    }
  }, [open, data]);

  const handleSubmit = () => {
    const normalizedSteps = form.steps.filter(Boolean);

    if (!form.lineNm.trim()) {
      alert('템플릿 이름을 입력하세요.');
      return;
    }
    if (normalizedSteps.length === 0) {
      alert('최소 1명의 결재 단계를 추가하세요.');
      return;
    }
    if (normalizedSteps.includes(currentUserUuid)) {
      alert('본인을 결재 단계에 포함할 수 없습니다.');
      return;
    }
    if (new Set(normalizedSteps).size !== normalizedSteps.length) {
      alert('같은 결재자를 중복 지정할 수 없습니다.');
      return;
    }

    onSave({
      lineNm: form.lineNm.trim(),
      docType: form.docType,
      steps: normalizedSteps.map((assigneeUsrUuid, index) => ({
        stepOrder: index + 1,
        assigneeUsrUuid,
      })),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{data ? 'V2 결재선 템플릿 수정' : 'V2 결재선 템플릿 등록'}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 0.5 }}>
          <Alert severity="info">
            이 템플릿은 approval v2 전용입니다. 휴가 신청과 수주품의서에서 legacy 결재선 대신 사용됩니다.
          </Alert>

          <TextField
            label="템플릿 이름"
            size="small"
            value={form.lineNm}
            onChange={(e) => setForm((prev) => ({ ...prev, lineNm: e.target.value }))}
            fullWidth
          />

          <TextField
            select
            label="대상 문서"
            size="small"
            value={form.docType}
            onChange={(e) => setForm((prev) => ({ ...prev, docType: e.target.value }))}
            fullWidth
          >
            {DOC_TYPE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <ApprovalStepEditor
            steps={form.steps}
            onChange={(steps) => setForm((prev) => ({ ...prev, steps }))}
            currentUserUuid={currentUserUuid}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">취소</Button>
        <Button onClick={handleSubmit} variant="contained">저장</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalLineTemplateModal;
